import { AlgoliaSearchFitmentResponse } from '@api-client/src/api/types';

export function mapToFitmentSearchResponse(fitmentSearchResponse: AlgoliaSearchFitmentResponse) {
  const results = fitmentSearchResponse.results || [];
  if (results.length === 0) return null;

  const searchResults = {
    results: results[0].hits.map((hit: any) => {
      return {
        record: {
          ...hit,
        },
      };
    }),
    totalSize: results[0].nbHits,
    resultsPerPage: results[0].hitsPerPage,
    page: results[0].page,
  };

  return searchResults;
}
